export function storeToken(token) {
    localStorage.setItem('token', token);
}

export function getToken() {
    return localStorage['token'] || null;
}



// WEBPACK FOOTER //
// ./src/js/utils/local-storage.js